import React from 'react'
import CheckBox from '../../common/checkBox/CheckBox'
import { i18n } from '../index'
import orderBy from 'lodash/orderBy'
import css from './dailyInfoBuffetMenu.css'

type Props = {
  edit?: boolean
  onChange: (...args: Array<any>) => any
  onCheckedChange: (...args: Array<any>) => any
  items: any
  allergyChecked: boolean
}

const buffetMenuOptions = ['lactoseFree', 'dairyFree', 'glutenFree', 'vegan']

class DailyInfoBuffetMenu extends React.Component<Props> {
  onCheckedChange = (isChecked: boolean) => {
    this.props.onCheckedChange(isChecked)
  }

  render() {
    const { edit, items } = this.props
    return (
      <div className={css.component}>
        <ul className={css.items}>
          {orderBy(items, 'dishType').map((item, i) => {
            return (
              <li key={`dish-${i}`} className={css.item}>
                <div className={css.itemName}>
                  <p className={css.value}>{item.dishName}</p>
                </div>
                {edit && (
                  <div className={css.itemCheckBoxes}>
                    {buffetMenuOptions.map((option, j) => {
                      return (
                        <CheckBox
                          key={`${i}-${j}`}
                          label={i18n.t(`dailyInfo.buffetMenu.${option}Label`)}
                          checked={!!item[option]}
                          disabled={true}
                        />
                      )
                    })}
                  </div>
                )}
                {!edit && (
                  <div className={css.itemCheckBoxes}>
                    {buffetMenuOptions
                      .map((option) => (!!item[option] ? i18n.t(`dailyInfo.buffetMenu.${option}Label`) : undefined))
                      .filter((item) => !!item)
                      .join(', ')}
                  </div>
                )}
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}

export default DailyInfoBuffetMenu
